/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { RS_ADDRESS, RS_ADDRESS_LOCALITY, RS_NAME, RS_POSTAL_CODE, SERVICE_EMAIL } from "../../services/globalVars";

const Privacy = () => {
  return (
    <div id="datenschutz">
      <Typography variant={"h1"}>Datenschutz</Typography>
      <Typography variant={"h2"}>Datenschutzerklärung für Legalbird OS</Typography>
      <Typography variant={"h3"}>Einleitung</Typography>
      <p>
        Für die Legalbird GmbH (<b>"LEGALBIRD"</b>) ist der Schutz und die Vertraulichkeit Ihrer Daten von besonderer
        Bedeutung. Die Erhebung und Verwendung Ihrer personenbezogenen Daten erfolgt ausschließlich im Rahmen der
        gesetzlichen Bestimmungen des geltenden Datenschutzrechts. Mit dieser Datenschutzerklärung informieren wir Sie
        darüber, welche personenbezogenen Daten LEGALBIRD erhebt und zu welchem Zweck die Daten verwendet werden und
        ggf. weitergegeben werden.
      </p>
      <p>
        Bitte lesen Sie diese Datenschutzerklärung vor der Nutzung unserer Legalbird Plattform (<b>"Legalbird OS"</b>)
        sorgfältig durch. Legalbird OS gibt Ihnen die Möglichkeit, Aufträge für juristische Arbeiten zu übernehmen und
        mit den bereitgestellten Werkzeugen effizient zu erledigen (<b>"Dienste"</b>). Mit dem Anklicken des Buttons,
        unter dem sich der Verweis und die Zustimmungserklärung auf diese Datenschutzerklärung befinden, bestätigen Sie,
        dass Sie diese Datenschutzerklärung zur Kenntnis genommen haben. Möchten Sie diese Datenschutzerklärung nicht
        anerkennen, ist eine Nutzung von Legalbird OS leider nicht möglich.
      </p>
      <br />
      <Typography variant={"h4"}>Verantwortliche Stelle</Typography>
      {RS_NAME}
      <br />
      Andreas Quauke
      <br />
      {RS_ADDRESS}
      <br />
      {RS_POSTAL_CODE} {RS_ADDRESS_LOCALITY}
      <br />
      {SERVICE_EMAIL}
      <br />
      <br />
      <Typography variant={"h3"}>I. Erhebung, Verarbeitung und Nutzung Ihrer Daten</Typography>
      <p>
        Zur Bereitstellung unserer Dienste ist die Erhebung, Verarbeitung und Nutzung von Daten und Informationen zu
        Ihrer Person (<b>"personenbezogene Daten"</b>) erforderlich. Wir verwenden Ihre personenbezogenen Daten gemäß
        Art. 6 Abs. 1 lit. b DSGVO ausschließlich zur Bereitstellung unserer Dienste für Sie bzw. aufgrund Ihrer
        Einwilligung gemäß Art. 9 Abs. 2 lit. a DSGVO, wenn Sie Ihre Rechtsdaten freiwillig auf Legalbird OS hochladen.
      </p>
      <Typography variant={"h4"}>Nutzungsdaten</Typography>
      <p>
        Zur Herstellung der Verbindung, Gewährleistung der Systemsicherheit und aus Gründen der technischen
        Administration, sowie um die Qualität und die Funktionsfähigkeit unserer Webseite zu verbessern und für den Fall
        einer Strafverfolgung sowie zu statistischen Zwecken erheben wir automatisch Daten über den einzelnen Zugriff
        auf unsere Seiten. Dieser Datensatz besteht unter anderem aus
      </p>
      <ul>
        <li>der Seite, von der aus die Plattform bzw. Webseite angefordert wurde,</li>
        <li>innerhalb der Webseite aufgerufenen Seiten,</li>
        <li>dem Datum und der Uhrzeit der Abfrage,</li>
        <li>der übertragenen Datenmenge,</li>
        <li>dem Zugriffsstatus (Datei übertragen, Datei nicht gefunden),</li>
        <li>Beschreibung des Typs des verwendeten Webbrowsers,</li>
        <li>der IP-Adresse des anfragenden Rechners</li>
        <li>dem verwendeten Betriebssystem</li>
      </ul>
      <p>
        Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen des
        Verantwortlichen).
      </p>
      <p>
        Die o.g. Gründe stellen auch das berechtigte Interesse für die Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO
        dar.
      </p>
      <br />
      <Typography variant={"h4"}>Cookies</Typography>
      <p>
        Zur besseren Benutzerführung setzen wir Cookies ein. Durch die Verwendung von Cookies wird die Nutzung von
        Webseiten für den Nutzer vereinfacht. Bestimmte Seiten sind ohne deren Einsatz nicht oder nicht fehlerfrei
        aufrufbar. Diese Gründe stellen auch das berechtigte Interesse für diese Datenverarbeitung nach Art. 6 Abs. 1
        lit. f DSGVO dar (die Nutzung von Cookies zu Analysezwecken wird in einem anderen Punkt behandelt). Gängige
        Browser bieten die Einstellungsmöglichkeit, Cookies nicht zuzulassen. Sie können Ihren Browser so einstellen,
        dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von
        Cookies ausschließen oder das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Es ist
        nicht gewährleistet, dass Sie auf alle Funktionen dieser Website ohne Einschränkungen zugreifen können, wenn Sie
        entsprechende Einstellungen vornehmen.
      </p>
      <p>
        Einen Überblick über die insgesamt auf Legalbird eingesetzten Technologien finden Sie in unserer{" "}
        <Link to={"/cookierichtlinie"}>Cookierichtlinie</Link>. Dort können Sie auch jederzeit Ihre Präferenzen
        hinsichtlich Ihrer Zustimmung ändern. Die jeweiligen Datenschutzerklärungen finden Sie bei den Betreibern der
        jeweiligen Services.
      </p>
      <br />
      <Typography variant={"h4"}>Google Analytics</Typography>
      <p>
        LEGALBIRD benutzt Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow
        Street, Dublin 4, Irland („Google“). Google Analytics verwendet sog. „Cookies“, Textdateien, die auf Ihrem
        Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den
        Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google
        in den USA übertragen und dort gespeichert. Auf dieser Webseite wurde Google Analytics um den Code
        „gat._anonymizeIp();“ erweitert, um eine anonymisierte Erfassung von IP-Adressen (sog. IP-Masking) zu
        gewährleisten. Dadurch wird Ihre IP-Adresse vorab von Google innerhalb der EU-Mitgliedsstaaten oder weiteren
        Mitgliedsstaaten oder des Europäischen Wirtschaftsraums gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse
        an einen Server von Google in den USA übertragen und dort gekürzt. Im Auftrag von LEGALBIRD wird Google diese
        Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten
        zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen
        gegenüber LEGALBIRD zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse
        wird nicht mit anderen Daten von Google zusammengeführt. Sie können die Erfassung der durch den
        Google-Analytics-Cookie generierten Daten, die sich auf die Nutzung der Webseite beziehen (einschließlich der
        IP-Adresse), durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch
        darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich
        werden nutzen können. Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre
        Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch
        Google verhindern, indem sie das unter dem folgenden Link verfügbare
        <a href="http://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Browser-Plugin{" "}
        </a>
        herunterladen und installieren.
      </p>
      <p>
        Sie können die Erfassung durch Google Analytics verhindern, indem Sie auf{" "}
        <a href="http://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer nofollow">
          diesen Link
        </a>{" "}
        klicken. Es wird ein Opt-Out-Cookie gesetzt, das die zukünftige Erfassung Ihrer Daten beim Besuch dieser
        Plattform verhindert
      </p>
      <p>
        Weitere Informationen zur Verwendung Ihrer Daten durch google finden Sie
        <a href="http://www.google.com/analytics/terms/de.html" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          hier
        </a>{" "}
        und
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          hier
        </a>
        .
      </p>
      <p>
        Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. LEGALBIRD hat
        ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung
        zu optimieren und dient damit auch der Finanzierung und kundenorientierten Nutzung, Anpassung und Aktualisierung
        der Webseite.
      </p>
      <br />
      <Typography variant={"h4"}>Verwendung von Google Adwords Conversion-Tracking</Typography>
      <p>
        Wir verwenden auf unserer Website das Online-Werbeprogramm „Google AdWords“ und in diesem Rahmen
        Conversion-Tracking (Besuchsaktionsauswertung). Das Google Conversion Tracking ist ein Analysedienst von Google.
        Wenn Sie auf eine von Google geschaltete Anzeige klicken, wird ein Cookie für das Conversion-Tracking auf Ihrem
        Rechner abgelegt. Zu diesem Cookie werden in der Regel als Analyse-Werte die Unique Cookie-ID, Anzahl Ad
        Impressions pro Platzierung (Frequency), letzte Impression (relevant für Post-View-Conversions) sowie
        Opt-out-Informationen (Markierung, dass der Nutzer nicht mehr angesprochen werden möchte) gespeichert. Diese
        Cookies haben eine begrenzte Gültigkeit, enthalten keine personenbezogenen Daten und dienen somit nicht der
        persönlichen Identifizierung. Wenn Sie bestimmte Seiten unserer Website besuchen und das Cookie noch nicht
        abgelaufen ist, können Google und wir erkennen, dass Sie auf die Anzeige geklickt haben und zu dieser Seite
        weitergeleitet wurden. Jeder Google AdWords-Kunde erhält ein anderes Cookie. Somit besteht keine Möglichkeit,
        dass Cookies über die Websites von AdWords-Kunden nachverfolgt werden können.
      </p>
      <p>
        Die Informationen, die mit Hilfe des Conversion-Cookies eingeholt werden, dienen dem Zweck
        Conversion-Statistiken zu erstellen. Hierbei erfahren wir die Gesamtanzahl der Nutzer, die auf eine unserer
        Anzeigen geklickt haben und zu einer mit einem Conversion-Tracking-Tag versehenen Seite weitergeleitet wurden.
        Wir bekommen von Google lediglich statistische Auswertungen zur Verfügung gestellt. Anhand dieser Auswertungen
        können wir erkennen, welche der eingesetzten Werbemaßnahmen besonders effektiv sind. Weitergehende Daten aus dem
        Einsatz der Werbemittel erhalten wir nicht, insbesondere können wir die Nutzer nicht anhand dieser Informationen
        identifizieren. Die Verarbeitung erfolgt auf Grundlage des Art. 6 (1) lit. f DSGVO aus dem berechtigten
        Interesse an zielgerichteter Werbung und der Analyse der Wirkung und Effizienz dieser Werbung.
      </p>
      <p>
        Sie haben das Recht aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit dieser auf Art. 6
        (1) f DSGVO beruhenden Verarbeitung Sie betreffender personenbezogener Daten zu widersprechen. Dazu können Sie
        die Speicherung der Cookies durch die Auswahl entsprechender technischer Einstellungen Ihrer Browser-Software
        verhindern.
      </p>
      <p>
        Des Weiteren können Sie in den Einstellungen für Werbung bei Google für Sie personalisierte Werbung
        deaktivieren. Hier finden Sie eine
        <a href="https://www.google.de/settings/ads" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Anleitung von Google{" "}
        </a>{" "}
        dazu. Darüber hinaus können Sie die Verwendung von Cookies durch Drittanbieter deaktivieren, indem sie die
        <a href="https://www.networkadvertising.org/choices/" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Deaktivierungsseite der Netzwerkwerbeinitiative{" "}
        </a>
        (Network Advertising Initiative) aufrufen und die dort genannten weiterführenden Information zum Opt-Out
        umsetzen. Weiterführende Informationen sowie die Datenschutzerklärung von Google finden Sie{" "}
        <a href="https://www.google.de/policies/privacy/" target="_blank" rel="noopener noreferrer nofollow">
          hier
        </a>
        .
      </p>
      <Typography variant={"h4"}>Google Maps Autocomplete</Typography>
      <p>
        Zur Unterstützung einer fehlerfreien Erfassung und Validierung von Adressdaten in unserem Backoffice-System
        (Legalbird OS) nutzen wir den Dienst Google Maps Autocomplete (Google Ireland Limited, Gordon House, Barrow
        Street, Dublin 4, Irland). Dies dient der Sicherstellung einer hohen Datenqualität der über die Antragsstrecken
        eingehenden Mandantendaten. Während der Eingabe werden Adressfragmente und die IP-Adresse des Nutzers an Google
        übertragen, um passende Vorschläge zu generieren. Die Verarbeitung erfolgt auf Grundlage unserer berechtigten
        Interessen an einer effizienten und korrekten Datenverwaltung sowie der Vermeidung von Übertragungsfehlern gemäß{" "}
        <strong>Art. 6 Abs. 1 lit. f DSGVO</strong>. Weitere Informationen finden Sie in der{" "}
        <a href="https://www.google.de/policies/privacy/" target="_blank" rel="noopener noreferrer nofollow">
          Datenschutzerklärung von Google
        </a>
        .
      </p>
      <Typography variant={"h4"}>Webfonts</Typography>
      <p>
        Auf dieser Webseite verwenden wir Web-Fonts (GoogleFonts, Adobe Typekit, Fonts.com o.ä.), also Schriften, die
        u.U. nicht auf Ihrem Endgerät vorhanden sind. Für diesen Dienst greifen wir auf eine Schrifttypenbibliothek
        zurück. Beim Aufruf unserer Webseite werden Web-Fonts von einem Server (Google, Adobe o.ä.) geladen. Dabei kann
        die IP-Adresse der aufrufenden Besucher an den Anbieter (z.B. Google, Adobe - Adobe Systems Inc., San Jose,
        Kalifornien, USA) übertragen werden. (GoogleFonts-Opt-out: https://adssettings.google.com)
      </p>
      <p>
        Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen des
        Verantwortlichen). Der Betreiber hat ein berechtigtes Interesse an einer gut lesbaren und strukturierten
        Darstellung von Schriften und Inhalten (Usability) auf der Webseite.
      </p>
      <Typography variant={"h4"}>Newsletter</Typography>
      <p>
        Wir bieten die Möglichkeit, sich per Newsletter über Neuerungen auf unserer Webseite zu informieren. Hierfür
        benötigen wir Ihre E-Mail-Adresse. Wenn Sie zu einem späteren Zeitpunkt den Newsletter nicht mehr beziehen
        möchten, ist dies über eine einfache E-Mail Abmeldung möglich.
      </p>
      <p>
        Sofern Sie eine Einwilligung in die werbliche Ansprache durch LEGALBIRD erteilt haben, erhebt, verarbeitet und
        nutzt LEGALBIRD Ihre Nutzerprofil-Daten, Buchungsdaten und Zusatzinformationen sowie Ihre Zugriffszeiten auf Ihr
        Nutzerprofil, um Ihre Nutzergewohnheiten besser zu verstehen und Ihnen für Sie möglicherweise interessante
        Informationen zu weiteren Dienstleistung zu übersenden. Sie können eine einmal erteilte Einwilligung in die
        Nutzung Ihrer Daten für werbliche Zwecke (z.B. Newsletter) durch LEGALBIRD und Anwalt von LEGALBIRD jederzeit
        durch E-Mail an {SERVICE_EMAIL} widerrufen.
      </p>
      <p>
        Rechtsgrundlage für die Verarbeitung der Daten nach Anmeldung zum Newsletter durch den Nutzer ist die
        Einwilligung des Nutzers, Art. 6 Abs. 1 lit. a DSGVO. Rechtsgrundlage für den Versand des Newsletters infolge
        des Verkaufs von Dienstleistungen ist § 7 Abs. 3 UWG.
      </p>
      <Typography variant={"h4"}>Allgemeine Registrierung</Typography>
      <p>
        Bei der Anmeldung in Legalbird OS müssen Sie Ihren Ihre E-Mail-Adresse angeben und Ihr Kennwort festlegen (
        <b>"Nutzerprofil-Daten"</b>). Diese Daten benötigen wir zur Einrichtung Ihres individuellen, nur für Sie
        zugänglichen Nutzerkontos für Legalbird OS (<b>"Legalbird-Konto</b>), über das wir Ihnen unsere Dienste zur
        Verfügung stellen. Wir können es Ihnen auch ermöglichen, sich über einen anderen Dienstleister anzumelden. Dies
        ist jedoch freiwillig und stellt lediglich eine Ergänzung des üblichen Anmeldeprozesses dar. Sollten Sie von
        diesem Angebot Gebrauch machen, unterliegt die Nutzung dieses anderen Dienstes den Nutzungsbedingungen des
        jeweiligen Anbieters und wir haben keinen Einfluss darauf, wie dieser Ihre Daten verarbeitet. Bitte machen Sie
        sich daher mit den Datenschutzbestimmungen des Dienstleisters vertraut.
      </p>
      <Typography variant={"h4"}>Weitere persönliche Daten</Typography>
      <p>
        Sie können in Ihrem Legalbird-Konto auch weitere Daten, die Sie in Ihrem Legalbird-Konto speichern möchten oder
        für die Sie unsere Dienste in Anspruch nehmen möchten, angeben oder speichern (
        <b>"weitere persönliche Daten"</b>). Weitere persönliche Daten sind z.B. Ihr Name und Vorname, Ihr Geschlecht,
        Ihre Bankverbindung oder Ihr Tätigkeitsschwerpunkt. Die Erhebung und Verarbeitung Ihrer weiteren persönlichen
        Daten durch uns erfolgt ausschließlich, um Ihnen unsere Dienste bereitzustellen.
      </p>
      <Typography variant={"h4"}>Gesprächsaufzeichnung und KI-gestützte Zusammenfassung</Typography>
      <p>
        Wir informieren Sie hiermit als <strong>Nutzer von Legalbird OS</strong>, dass{" "}
        <strong>Ihre Beratungsgespräche</strong> mit Mandanten zu Dokumentationszwecken aufgezeichnet werden können.
        Voraussetzung für die Aufzeichnung ist die <strong>vorherige, ausdrückliche Zustimmung beider</strong>{" "}
        Gesprächsparteien (<strong>Ihre Zustimmung als Nutzer der Plattform</strong> sowie die des Mandanten). Die
        Verarbeitung Ihrer Gesprächsdaten erfolgt in diesem Rahmen.
      </p>
      <p>
        Die Aufzeichnung erfolgt über den von uns genutzten Softwaredienstleister, der hierzu die technischen Dienste
        von <strong>Twilio Ireland Limited</strong> nutzt. Zweck der Aufzeichnung ist ausschließlich die Erstellung
        einer <strong>KI-gestützten Gesprächszusammenfassung</strong>. Diese Zusammenfassung erfolgt mithilfe eines der{" "}
        <strong>KI-Dienstleister</strong>, die im Abschnitt{" "}
        <strong>"Nutzung von KI zur unterstützenden Mandatsbearbeitung"</strong> genannt sind, und dient dazu, die
        rechtliche Beratung besser nachvollziehbar zu dokumentieren.
      </p>
      <p>
        Zusätzlich können <strong>pseudonymisierte Gesprächszusammenfassungen</strong> zu Qualitätssicherungs- und
        Trainingszwecken verwendet werden. Diese Daten werden unter Anwendung geeigneter technischer und
        organisatorischer Maßnahmen verarbeitet und enthalten keine unmittelbar identifizierbaren personenbezogenen
        Informationen.
      </p>
      <p>
        Unser Softwaredienstleister <strong>Twilio Ireland Limited</strong> ist in Europa ansässig. Für mögliche
        Datenübermittlungen in Drittstaaten durch die eingesetzten KI-Dienstleister verweisen wir auf die Informationen
        im Abschnitt <strong>"Nutzung von KI zur unterstützenden Mandatsbearbeitung"</strong>. Die
        Gesprächsaufzeichnungen werden spätestens <strong>14 Tage</strong> nach Gesprächsende gelöscht.
        Die Zusammenfassungen selbst werden bis zum Ende des jeweiligen Mandats gespeichert.
      </p>
      <p>
        Wird die Einwilligung widerrufen, führt dies zur sofortigen Beendigung der Gesprächsaufzeichnung und zur
        Löschung bereits aufgezeichneter Daten. Unser Softwaredienstleister hat mit Twilio und den eingesetzten
        KI-Dienstleistern entsprechende <strong>Auftragsverarbeitungsverträge gemäß Art. 28 DSGVO</strong>{" "}
        abgeschlossen, um sicherzustellen, dass die personenbezogenen Daten nur nach unserer Weisung verarbeitet und
        nicht für andere Zwecke genutzt werden. Das Data-Protection-Addendum von Twilio finden Sie unter:{" "}
        <a
          href="https://www.twilio.com/legal/data-protection-addendum"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          Data Protection Addendum
        </a>
        .
      </p>
      <Typography variant={"h4"}>Nutzung von KI zur unterstützenden Mandatsbearbeitung</Typography>
      <p>
        Zur Unterstützung unserer anwaltlichen Mandatsbearbeitung setzen wir KI-gestützte Technologien ein. Dazu gehört
        unsere <strong>Legalbird AI</strong>, die auf Modelle externer KI-Anbieter wie{" "}
        <strong>Google Ireland Limited</strong> und <strong>OpenAI Ireland Limited</strong> zurückgreift. Diese Systeme
        dienen insbesondere der strukturierten Auswertung und Aufbereitung von Fallinformationen, der Texterkennung
        sowie der internen Unterstützung bei der juristischen Analyse und Recherche. Ziel ist es, unsere Arbeitsprozesse
        effizienter zu gestalten und unsere Beratungsqualität zu verbessern.
      </p>
      <p>
        Die Verarbeitung personenbezogener Daten erfolgt auf Grundlage unseres <strong>berechtigten Interesses</strong>{" "}
        gemäß Art. 6 Abs. 1 lit. f DSGVO an einer modernen, effizienten und qualitativ hochwertigen Mandatsbearbeitung.
        Sie können dieser Verarbeitung jederzeit aus Gründen, die sich aus Ihrer besonderen Situation ergeben,
        widersprechen (Art. 21 DSGVO).
      </p>
      <p>
        Die Beauftragung von <strong>Google Ireland Limited</strong> und <strong>OpenAI Ireland Limited</strong> erfolgt
        gemäß Art. 28 DSGVO in Verbindung mit entsprechenden Auftragsverarbeitungsverträgen. Diese Anbieter agieren
        dabei als weisungsgebundene Auftragsverarbeiter und nutzen die übermittelten Daten nicht für eigene Zwecke. Ihre
        personenbezogenen Daten können an Google Ireland Limited, OpenAI Ireland Limited und deren verbundene
        Unternehmen weitergegeben werden. Es ist möglich, dass dies auch eine{" "}
        <strong>Datenübermittlung an verbundene Unternehmen in den USA</strong> umfasst. In diesem Zusammenhang stellen
        wir durch geeignete Schutzmaßnahmen sicher, dass Ihre Daten im Einklang mit den Art. 44 ff. DSGVO verarbeitet
        werden. Weitere Informationen finden Sie in den 'Data Processing Addenda' (DPA) der jeweiligen Anbieter.
      </p>
      <Typography variant={"h3"}>II. Weitergabe an Dritte</Typography>
      <p>
        Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt nur, soweit dies zur Bereitstellung und Nutzung
        unserer Dienste und zur Zahlungsabwicklung unbedingt notwendig ist. Diese Weitergaben sind für die
        ordnungsgemäße Erbringung unserer Dienste erforderlich und erfolgt im Einklang mit dem geltenden
        Datenschutzrecht.
      </p>
      <Typography variant={"h4"}>Unsere Dienstleister</Typography>
      <p>
        Wir beauftragen dritte Unternehmen mit der Erfüllung von Aufgaben zum Zweck der Bereitstellung unserer Dienste (
        <b>"Auftragsverarbeiter"</b>). Unsere Auftragsverarbeiter haben Zugang zu personenbezogenen Daten, die zur
        Erfüllung ihrer Aufgaben benötigt werden. Wir verlangen von unseren Auftragsverarbeitern im Rahmen der
        gesetzlichen Anforderungen eine Einverständniserklärung zur vertraulichen Behandlung sämtlicher an diese
        weitergegebener Informationen sowie zur ausschließlichen Nutzung der Informationen im Rahmen des Vertragszwecks.
      </p>
      <Typography variant={"h4"}>Von Ihnen ausgewählte Aufträge</Typography>
      <p>
        Nur dann, wenn Sie Aufträge in Legalbird OS annehmen und dadurch Ihre Einwilligung erklärt haben, für die
        Erledigung des Auftrags notwendige (weitere) persönliche Daten (insbesondere Ihren Namen und Ihre Anrede) an den
        Mandanten weiterzugeben, geben wir diese weiteren persönlichen Daten an den Mandanten weiter.
      </p>
      <Typography variant={"h4"}>Rechtwidrige Nutzung von Legalbird OS</Typography>
      <p>
        Wenn es zur Aufklärung einer rechtswidrigen Nutzung von Legalbird OS dient oder für die Rechtsverfolgung
        erforderlich ist, werden personenbezogene Daten an die Strafverfolgungsbehörden sowie ggf. an geschädigte Dritte
        weitergeleitet. Dies geschieht jedoch nur dann, wenn konkrete Anhaltspunkte für ein gesetzwidriges bzw.
        missbräuchliches Verhalten vorliegen. Eine Weitergabe kann auch dann stattfinden, wenn dies der Durchsetzung der
        AGB oder anderer Vereinbarungen dient. LEGALBIRD ist zudem gesetzlich verpflichtet, auf Anfrage bestimmten
        öffentlichen Stellen Auskunft zu erteilen. Dies sind Strafverfolgungsbehörden, Behörden, die bußgeldbewährte
        Ordnungswidrigkeiten verfolgen und die Finanzbehörden.
      </p>
      <Typography variant={"h3"}>III. Datensicherheit</Typography>
      <p>
        Ihre personenbezogenen Daten werden während der Übertragung über das Internet mittels Transport Layer Security /
        Secure Sockets Layer (TLS / SSL) verschlüsselt.
      </p>
      <p>
        Wir sichern unsere Website und sonstigen Systeme durch technische und organisatorische Maßnahmen gegen Verlust,
        Zerstörung, Zugriff, Veränderung oder Verbreitung Ihrer Daten durch unbefugte Personen.
      </p>
      <Typography variant={"h3"}>IV. Speicherdauer und Löschung</Typography>
      <p>
        Das Kriterium für die Dauer der Speicherung von personenbezogenen Daten ist die jeweilige gesetzlich
        vorgeschriebene Aufbewahrungsfrist. Nach Ablauf der Frist werden die entsprechenden Daten routinemäßig gelöscht,
        sofern sie nicht mehr zur Vertragserfüllung oder Vertragsanbahnung erforderlich sind.
      </p>
      <p>
        Soweit Ihre Daten für die vorgenannten Zwecke nicht mehr erforderlich sind, werden sie gelöscht. Soweit Daten
        aus gesetzlichen Gründen aufbewahrt werden müssen, werden diese gesperrt. Die Daten stehen einer weiteren
        Verwendung dann nicht mehr zur Verfügung.
      </p>
      <p>
        Sie können Ihren Account nicht selbständig löschen, jedoch jederzeit eine Löschung Ihrer Daten per E-Mail an{" "}
        {SERVICE_EMAIL} anfordern. Wir löschen Ihre Daten auf Anforderung, insofern diese nicht aus Abrechnungsgründen
        oder zur Wahrung gesetzlicher Aufbewahrungsfristen benötigt werden.
      </p>
      <Typography variant={"h3"}>VI. Ihre Rechte</Typography>
      <Typography variant={"h4"}>Widerrufsrecht</Typography>
      <p>
        Sie können Ihre Einwilligung zur Erhebung und Verarbeitung Ihrer personenbezogenen Daten durch uns jederzeit
        widerrufen.
      </p>
      <Typography variant={"h4"}>Auskunftsanspruch</Typography>
      <p>
        Sie haben das Recht, gemäß § 34 BDSG bzw. Art. 15 DSGVO jederzeit von uns Auskunft zu verlangen über die zu
        Ihrer Person gespeicherten Daten, auch soweit sie sich auf die Herkunft dieser Daten beziehen, ebenso zu den
        Empfängern oder den Kategorie von Empfängern, an die Ihre Daten weitergegeben werden, sowie zum Zweck der
        Speicherung.
      </p>
      <Typography variant={"h4"}>Weitere Rechte</Typography>
      <p>
        Sie haben das Recht, gemäß Art. 16 DSGVO die Berichtigung unrichtiger personenbezogener Daten und gemäß Art. 17
        DSGVO die Löschung oder gemäß Art. 18 DSGVO die Sperrung oder Einschränkung der Verarbeitung Ihrer
        personenbezogenen Daten zu verlangen. Ferner können Sie gemäß Art. 20 DSGVO die Herausgabe der zu Ihnen
        gespeicherten personenbezogenen Daten in einem gängigen Dateiformat an Sie selbst oder einen Dritten verlangen.
        Sofern wir Ihre personenbezogenen Daten aufgrund unserer überwiegenden Interessen (Art. 6 Abs. 1 lit. f DSGVO)
        verarbeiten, können Sie einer darauf gestützten Verarbeitung gemäß Art. 21 DSGVO widersprechen, sofern hierfür
        überwiegende Gründe bestehen, die sich aus Ihrer besonderen Situation ergeben. Sie können ferner der Zusendung
        von Direktwerbung widersprechen. Sollten Sie der Auffassung sein, dass wir Ihre Daten nicht im Einklang mit
        geltendem Recht verarbeiten, können Sie eine Beschwerde bei einer zuständigen Aufsichtsbehörde einlegen, z.B. an
        Ihrem Wohnort.
      </p>
      <p>Stand: 21. April 2026</p>
    </div>
  );
};

export default Privacy;
